export default {
  assemblePage: {
    QuickJoin: '快速参团 立即拼成',
    PeopleGroup: '人团',
    InProgress: '正在拼，还差',
    PeopletoComplete: '人拼成',
    JoinDirectly: '直接参团',
    MustJoin: '本周必拼',
    line: '我是有底线的',
    JoinNow: '马上拼',
    Oops: '哎呀，没有相关拼团呢～',
    Why: '这里的拼团怎么这么划算',
    Groupbuying: '拼团一时爽，一直拼团一直爽！'
  }
}
